var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTree2 = function SvgTree2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 106 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.109 52.721c0 29.119-23.603 52.722-52.721 52.722C-17.47 102.858-17.456 2.569 52.388 0c29.118 0 52.721 23.603 52.721 52.721Z",
    fill: "#99EDBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.995 176.118a.771.771 0 0 1-.77-.77V40.528c-.016-.999 1.556-.999 1.54 0v134.828c0 .424-.346.77-.77.77v-.008Z",
    fill: "#566C77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.728 69.622a.774.774 0 0 1-.597-.283L40.115 55.96a.772.772 0 0 1 .11-1.085.765.765 0 0 1 1.085.102l11.015 13.381c.267.33.22.817-.11 1.085a.764.764 0 0 1-.487.18ZM51.986 88.77a.767.767 0 0 1-.62-1.226l14.166-19.147a.767.767 0 0 1 1.077-.157c.345.25.416.73.165 1.076L52.607 88.464a.77.77 0 0 1-.62.314v-.008Z",
    fill: "#566C77"
  })));
};
export default SvgTree2;